// [id: string, quantity: int]
async function addItemsToCart(items) {
  const addUrl = `${window.Shopify.routes.root}cart/add.js`;

  if (items.length > 0) {
    try {
      const data = await fetch(addUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items }),
      });
      return data;
    } catch (error) {
      console.error("Error adding items to cart:", items, error);
    }
  }
}

console.log('adding NttUtils')
window.NttUtils = window.NttUtils ?? {};
window.NttUtils.addItemsToCart = addItemsToCart;
